import '@babel/register';
// eslint-disable-next-line import/no-unresolved
import 'css-cm-ui';
// eslint-disable-next-line import/no-unresolved
import 'images/browser-icons-24px.png';

import React from 'react';
import { StylesProvider } from '@material-ui/styles';
import { versions } from '@saddlebackchurch/react-cm-ui';
import {
    theme,
    ThemeProvider,
} from '@saddlebackchurch/react-cm-ui/core/styles';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import {
    browserHistory,
    Router,
} from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { appReduxStore } from './global/configureReduxStore.js';
import routes from './routes.js';
import jssPreset from './tools/jssPreset.js';

window.versions = versions;

function onRouterUpdate() {
    // Ensure we scroll to the top of the page when we transition to a new route
    window.scrollTo(0, 0);
}

const container = document.getElementById('coreApp');
const history = syncHistoryWithStore(browserHistory, appReduxStore);
const root = ReactDOM.createRoot(container);
const jss = jssPreset();

root.render(
    <StylesProvider jss={jss}>
        <ThemeProvider theme={theme}>
            <Provider store={appReduxStore}>
                <Router
                    history={history}
                    onUpdate={onRouterUpdate}
                    routes={routes}
                />
            </Provider>
        </ThemeProvider>
    </StylesProvider>,
);
